{
  "data": [
    {
      "alpha2": "GB",
      "alpha3": "GBR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "5c2edd3e-6003-4a84-a365-e5c817e1dd72",
      "name": "United Kingdom of Great Britain and Northern Ireland",
      "phoneCode": "+44",
      "region": "EUROPE",
      "sortOrder": 1,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AL",
      "alpha3": "ALB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "630d5d35-4da7-4f55-9790-a0b21fe41e1f",
      "name": "Albania",
      "phoneCode": "+355",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AT",
      "alpha3": "AUT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0dad8cb5-527a-4eda-8a01-238cb0b75a4f",
      "name": "Austria",
      "phoneCode": "+43",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BY",
      "alpha3": "BLR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ee766b21-23b6-4e98-af82-3aca9382c835",
      "name": "Belarus",
      "phoneCode": "+375",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BE",
      "alpha3": "BEL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "11d1eb17-20ac-492d-9910-3c61a18c6998",
      "name": "Belgium",
      "phoneCode": "+32",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BA",
      "alpha3": "BIH",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "2002aa49-176f-4bdb-a704-ece574d9b4a0",
      "name": "Bosnia and Herzegovina",
      "phoneCode": "+387",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BG",
      "alpha3": "BGR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0e0ec07f-04f1-4dd9-9919-a0840611995f",
      "name": "Bulgaria",
      "phoneCode": "+359",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "HR",
      "alpha3": "HRV",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c58632b6-01cb-4175-bbab-ba97468f2f46",
      "name": "Croatia",
      "phoneCode": "+385",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CY",
      "alpha3": "CYP",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a89d7283-d677-499e-98e7-2648a3b2e868",
      "name": "Cyprus",
      "phoneCode": "+357",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CZ",
      "alpha3": "CZE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "8f3a911f-7700-4ded-b398-5114a237976d",
      "name": "Czechia",
      "phoneCode": "+420",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "DK",
      "alpha3": "DNK",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ea7ea130-d717-4fd1-bb62-34edaf19ab1f",
      "name": "Denmark",
      "phoneCode": "+45",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "EE",
      "alpha3": "EST",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "786ccad0-21f7-4b8a-9179-2b757f4a3b04",
      "name": "Estonia",
      "phoneCode": "+372",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "FI",
      "alpha3": "FIN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "44c978ea-0190-44c2-b2d7-9f15828dfddc",
      "name": "Finland",
      "phoneCode": "+358",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "FR",
      "alpha3": "FRA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "5e55f14a-c3b9-45ea-9dd3-e1a5a87f13f8",
      "name": "France",
      "phoneCode": "+33",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "DE",
      "alpha3": "DEU",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "9b2e01b4-de66-4402-ae39-9eab2df1ad64",
      "name": "Germany",
      "phoneCode": "+49",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GR",
      "alpha3": "GRC",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "4f49850c-ef5e-40d5-89e2-bdd3809d57f9",
      "name": "Greece",
      "phoneCode": "+30",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "HU",
      "alpha3": "HUN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "11f8a153-e389-4d08-bc16-e87105437f0d",
      "name": "Hungary",
      "phoneCode": "+36",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "IS",
      "alpha3": "ISL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0a0a7e7f-7bb1-4874-9e4a-052e93ea6bc5",
      "name": "Iceland",
      "phoneCode": "+354",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "IE",
      "alpha3": "IRL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "aa6239f8-23b4-4f93-89f2-164a156f396e",
      "name": "Ireland",
      "phoneCode": "+353",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "IT",
      "alpha3": "ITA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "50d49469-26ab-4360-9ced-56332f5419ad",
      "name": "Italy",
      "phoneCode": "+39",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LV",
      "alpha3": "LVA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "2d5d9a51-42c4-4ef5-ad71-fe423a2c525b",
      "name": "Latvia",
      "phoneCode": "+371",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LI",
      "alpha3": "LIE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "8ffc18f8-056c-490f-bab7-e298a7420005",
      "name": "Liechtenstein",
      "phoneCode": "+423",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LT",
      "alpha3": "LTU",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c8a24296-0122-4dff-bcdc-5dd2aec8c956",
      "name": "Lithuania",
      "phoneCode": "+370",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LU",
      "alpha3": "LUX",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "fe6fbda7-f97a-4fb2-a8bb-9804795b0818",
      "name": "Luxembourg",
      "phoneCode": "+352",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MT",
      "alpha3": "MLT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "abddbb52-02a7-4ef9-91ab-f09132cea4c5",
      "name": "Malta",
      "phoneCode": "+356",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MD",
      "alpha3": "MDA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "7726ac8a-d6fe-47bc-b90a-fb8f90c38036",
      "name": "Moldova",
      "phoneCode": "+373",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MC",
      "alpha3": "MCO",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "fe53d00d-4c99-4a0c-b79f-d8a7d9968d1a",
      "name": "Monaco",
      "phoneCode": "+377",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ME",
      "alpha3": "MNE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "5db4cbeb-9f05-4199-b73c-eaa31918524c",
      "name": "Montenegro",
      "phoneCode": "+382",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NL",
      "alpha3": "NLD",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0ef71717-81a7-44b3-a944-401769ad5050",
      "name": "Netherlands",
      "phoneCode": "+31",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MK",
      "alpha3": "MKD",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "33341b26-be85-4af2-b13a-c515cf75575f",
      "name": "North Macedonia",
      "phoneCode": "+389",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NO",
      "alpha3": "NOR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ce6330f9-cbd8-485b-8b17-849d6248629e",
      "name": "Norway",
      "phoneCode": "+47",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PL",
      "alpha3": "POL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d91e6f69-c9ff-48f4-b5e6-75de1189a8a6",
      "name": "Poland",
      "phoneCode": "+48",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PT",
      "alpha3": "PRT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "6ea9ea52-ca14-4050-85b7-8254e50e9e69",
      "name": "Portugal",
      "phoneCode": "+351",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "RO",
      "alpha3": "ROU",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d885e9a4-dc7e-4358-8a57-0dd67b0d6332",
      "name": "Romania",
      "phoneCode": "+40",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "RU",
      "alpha3": "RUS",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "8e72f487-8e61-4a21-a61a-9e055e4d5331",
      "name": "Russia",
      "phoneCode": "+7",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SM",
      "alpha3": "SMR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "796b61b9-4322-4f2a-80ce-5108bae40b28",
      "name": "San Marino",
      "phoneCode": "+378",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "RS",
      "alpha3": "SRB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "6ee2b3a6-4c0d-4a55-889b-993f4feb807e",
      "name": "Serbia",
      "phoneCode": "+381",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SK",
      "alpha3": "SVK",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "428541c6-2ea9-4845-8884-ae7d5d411101",
      "name": "Slovakia",
      "phoneCode": "+421",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SI",
      "alpha3": "SVN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0222f21f-907a-4caa-88c9-77863d4ff871",
      "name": "Slovenia",
      "phoneCode": "+386",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ES",
      "alpha3": "ESP",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "2707973a-25e4-4243-bca2-95c66385c23e",
      "name": "Spain",
      "phoneCode": "+34",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SE",
      "alpha3": "SWE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a771efc0-ea07-4e58-91ea-3c70a3864a0c",
      "name": "Sweden",
      "phoneCode": "+46",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CH",
      "alpha3": "CHE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "65165076-3707-4c61-bc49-c4b0d560521d",
      "name": "Switzerland",
      "phoneCode": "+41",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "UA",
      "alpha3": "UKR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d8b32beb-1058-41fb-9d49-75ecb4b9fd80",
      "name": "Ukraine",
      "phoneCode": "+380",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "VA",
      "alpha3": "VAT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "32f644a6-6398-48c0-834e-9b8712353662",
      "name": "Vatican City",
      "phoneCode": "+379",
      "region": "EUROPE",
      "sortOrder": 2,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AF",
      "alpha3": "AFG",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "87628d92-37a2-4aff-9b04-af0fc64e9f30",
      "name": "Afghanistan",
      "phoneCode": "+93",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AM",
      "alpha3": "ARM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "f7381192-4f0a-497e-bf7a-3e27d0178bc8",
      "name": "Armenia",
      "phoneCode": "+374",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AZ",
      "alpha3": "AZE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "b829029a-e962-478c-b05d-9d5116e553b9",
      "name": "Azerbaijan",
      "phoneCode": "+994",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BH",
      "alpha3": "BHR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "7966cf0c-ca82-4a23-b320-6653c349d746",
      "name": "Bahrain",
      "phoneCode": "+973",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BD",
      "alpha3": "BGD",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "20f846b1-8067-41dc-962a-89c2c993f08f",
      "name": "Bangladesh",
      "phoneCode": "+880",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BT",
      "alpha3": "BTN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "9aeeceb4-138c-45de-afce-49dcc49548ac",
      "name": "Bhutan",
      "phoneCode": "+975",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BN",
      "alpha3": "BRN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "16b37b66-dfd3-4560-9e2e-a4ce9d3a7181",
      "name": "Brunei",
      "phoneCode": "+673",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KH",
      "alpha3": "KHM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "b8190ebb-f4fd-4113-a3b4-9a9f7bda2451",
      "name": "Cambodia",
      "phoneCode": "+855",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CN",
      "alpha3": "CHN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "b1a1a300-be0c-42ae-8934-c09f320fdf99",
      "name": "China",
      "phoneCode": "+86",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TL",
      "alpha3": "TLS",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "78a682cd-204c-480b-9a22-df2a9eb1d5e3",
      "name": "East Timor",
      "phoneCode": "+670",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GE",
      "alpha3": "GEO",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "475dd158-fb2a-44c9-b72a-af4d8c94cecc",
      "name": "Georgia",
      "phoneCode": "+995",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "IN",
      "alpha3": "IND",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "acafabfe-e3a5-468a-8c87-e93e88190096",
      "name": "India",
      "phoneCode": "+91",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ID",
      "alpha3": "IDN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ac08e33a-d527-42c3-af39-2498163ad287",
      "name": "Indonesia",
      "phoneCode": "+62",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "IR",
      "alpha3": "IRN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "3f1bd683-deab-415d-9111-bfc6b115cd4d",
      "name": "Iran",
      "phoneCode": "+98",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "IQ",
      "alpha3": "IRQ",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "e1519667-a7f0-42ea-b506-ef712a570be9",
      "name": "Iraq",
      "phoneCode": "+964",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "IL",
      "alpha3": "ISR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "75532ca4-bbf6-46d1-b988-10848b3abfe3",
      "name": "Israel",
      "phoneCode": "+972",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "JP",
      "alpha3": "JPN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "edc92861-e1fc-4e42-9feb-83a1aa150842",
      "name": "Japan",
      "phoneCode": "+81",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "JO",
      "alpha3": "JOR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "f7c601e9-50fb-48d3-be59-57ccf01840e6",
      "name": "Jordan",
      "phoneCode": "+962",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KZ",
      "alpha3": "KAZ",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "58a87753-9745-406d-a543-bd9ca294a399",
      "name": "Kazakhstan",
      "phoneCode": "+7",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KW",
      "alpha3": "KWT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c2c06020-6db7-4a87-b79b-4405376f1252",
      "name": "Kuwait",
      "phoneCode": "+965",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KG",
      "alpha3": "KGZ",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "324ee902-f716-4567-afa9-4139e7d61caf",
      "name": "Kyrgyzstan",
      "phoneCode": "+996",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LA",
      "alpha3": "LAO",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "5df78f58-1be6-4ed3-82e6-35391ea28ada",
      "name": "Laos",
      "phoneCode": "+856",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LB",
      "alpha3": "LBN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "082430bd-4ea6-45af-8ef4-8e5ef54727db",
      "name": "Lebanon",
      "phoneCode": "+961",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MY",
      "alpha3": "MYS",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "e218c2de-2a03-4d13-a757-183f2638790b",
      "name": "Malaysia",
      "phoneCode": "+60",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MV",
      "alpha3": "MDV",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "306a58df-3065-43c2-b450-719682adcd55",
      "name": "Maldives",
      "phoneCode": "+960",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MN",
      "alpha3": "MNG",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "f48b4810-0544-47f3-826c-676acceefda3",
      "name": "Mongolia",
      "phoneCode": "+976",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MM",
      "alpha3": "MMR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ccd119a2-3bbb-4ff6-949d-3086a2f990e0",
      "name": "Myanmar",
      "phoneCode": "+95",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NP",
      "alpha3": "NPL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0f7fa053-fff2-4557-9ba2-41e3d3e43816",
      "name": "Nepal",
      "phoneCode": "+977",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KP",
      "alpha3": "PRK",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "15b615ac-0a36-4329-a848-ffd753a6d3bb",
      "name": "North Korea",
      "phoneCode": "+850",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "OM",
      "alpha3": "OMN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "f234119c-51fb-4b58-a49d-99e4cd12cc58",
      "name": "Oman",
      "phoneCode": "+968",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PK",
      "alpha3": "PAK",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d41c9edc-aa47-4b2b-83bc-5464d3bb8ead",
      "name": "Pakistan",
      "phoneCode": "+92",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PS",
      "alpha3": "PSE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0d85f12c-9b78-447f-b6c0-3c320777c54d",
      "name": "Palestine",
      "phoneCode": "+970",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PH",
      "alpha3": "PHL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a8d2bc30-bb72-4ea6-a15f-3a236154d796",
      "name": "Philippines",
      "phoneCode": "+63",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "QA",
      "alpha3": "QAT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "4855f9df-9b6c-4b1e-8778-380afebac4d5",
      "name": "Qatar",
      "phoneCode": "+974",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SA",
      "alpha3": "SAU",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c15b163b-9831-4a32-ae1f-29f7f29af08a",
      "name": "Saudi Arabia",
      "phoneCode": "+966",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SG",
      "alpha3": "SGP",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0b3802c2-54f4-401e-95a6-f2893a04d42a",
      "name": "Singapore",
      "phoneCode": "+65",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KR",
      "alpha3": "KOR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "95364dec-816f-43eb-80ae-34e8ac780555",
      "name": "South Korea",
      "phoneCode": "+82",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LK",
      "alpha3": "LKA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a19ac254-a639-402c-8ada-7d6e42d69522",
      "name": "Sri Lanka",
      "phoneCode": "+94",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SY",
      "alpha3": "SYR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a98ce2b3-b3e2-44a0-a1c7-410235706ac5",
      "name": "Syria",
      "phoneCode": "+963",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TW",
      "alpha3": "TWN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "6ea66530-a152-440b-a8fa-c2acffe701cc",
      "name": "Taiwan",
      "phoneCode": "+886",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TJ",
      "alpha3": "TJK",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "7dff9b5d-07e7-4170-96a0-89c04935d8fb",
      "name": "Tajikistan",
      "phoneCode": "+992",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TH",
      "alpha3": "THA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "69bf945c-3c82-4a4d-839f-bfd64afbdda2",
      "name": "Thailand",
      "phoneCode": "+66",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TR",
      "alpha3": "TUR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a3b45abf-b6e6-46cc-ae99-dedb80326ffa",
      "name": "Turkey",
      "phoneCode": "+90",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TM",
      "alpha3": "TKM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c32e1336-e409-4e69-abbb-b0ee06d6b170",
      "name": "Turkmenistan",
      "phoneCode": "+993",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AE",
      "alpha3": "ARE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "02b54be3-f3c9-4182-bbdb-2607c659a805",
      "name": "United Arab Emirates",
      "phoneCode": "+971",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "UZ",
      "alpha3": "UZB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a932b223-30f9-4e6c-828b-199786288179",
      "name": "Uzbekistan",
      "phoneCode": "+998",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "VN",
      "alpha3": "VNM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "1584b2f4-72b6-4833-a9d2-3b64a4dd1ba9",
      "name": "Vietnam",
      "phoneCode": "+84",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "YE",
      "alpha3": "YEM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "80af9de4-0495-4423-9f3b-87fb448c1f16",
      "name": "Yemen",
      "phoneCode": "+967",
      "region": "ASIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "DZ",
      "alpha3": "DZA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "204f48b0-4534-4117-837f-b6eca059c11a",
      "name": "Algeria",
      "phoneCode": "+213",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AO",
      "alpha3": "AGO",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "18d82def-592c-4ea8-87d3-9c3695970408",
      "name": "Angola",
      "phoneCode": "+244",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BJ",
      "alpha3": "BEN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "8fd95ab5-809b-414d-a5af-9378485e83b3",
      "name": "Benin",
      "phoneCode": "+229",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BW",
      "alpha3": "BWA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "82b878d7-7e6c-4ffc-a272-1b98b04cf4f7",
      "name": "Botswana",
      "phoneCode": "+267",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BF",
      "alpha3": "BFA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "1ce370d8-cc65-4211-a94d-ba623ee050bb",
      "name": "Burkina Faso",
      "phoneCode": "+226",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BI",
      "alpha3": "BDI",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c067dc51-6643-4ebc-a139-0e954ded34e9",
      "name": "Burundi",
      "phoneCode": "+257",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CM",
      "alpha3": "CMR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "5bb8885a-af67-41e8-82ad-d4819ab140d6",
      "name": "Cameroon",
      "phoneCode": "+237",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CV",
      "alpha3": "CPV",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "6520e1df-3e1f-4980-8dc3-66058fac75ea",
      "name": "Cape Verde",
      "phoneCode": "+238",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CF",
      "alpha3": "CAF",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "3fbce231-74c0-488d-862a-e0776423d5dc",
      "name": "Central African Republic",
      "phoneCode": "+236",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TD",
      "alpha3": "TCD",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "9502a7b8-f945-4277-b215-8a65bddd78e1",
      "name": "Chad",
      "phoneCode": "+235",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KM",
      "alpha3": "COM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ee585eea-7df7-4bb0-bca3-3da79ffa558c",
      "name": "Comoros",
      "phoneCode": "+269",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CD",
      "alpha3": "COD",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "8e3e6089-2121-453e-bd35-526db9f55189",
      "name": "Democratic Republic of the Congo",
      "phoneCode": "+243",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "DJ",
      "alpha3": "DJI",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "e8125b24-eab1-475c-b79d-b62d2a7a4fb0",
      "name": "Djibouti",
      "phoneCode": "+253",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "EG",
      "alpha3": "EGY",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0f724132-d55e-4c85-98a9-345c4fa43720",
      "name": "Egypt",
      "phoneCode": "+20",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GQ",
      "alpha3": "GNQ",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "24fd13ce-a9aa-4b6f-a0c9-e4c39830409f",
      "name": "Equatorial Guinea",
      "phoneCode": "+240",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ER",
      "alpha3": "ERI",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "68f1ac9a-1764-469f-b273-ad6f5308430c",
      "name": "Eritrea",
      "phoneCode": "+291",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ET",
      "alpha3": "ETH",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "7335a434-1ee9-4dc3-9291-07976e4bbf6e",
      "name": "Ethiopia",
      "phoneCode": "+251",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GA",
      "alpha3": "GAB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "184466d8-a897-43f6-8b5a-290aaf14c4de",
      "name": "Gabon",
      "phoneCode": "+241",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GM",
      "alpha3": "GMB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "e7f31652-7d5c-4dcf-8995-9e109861d079",
      "name": "Gambia",
      "phoneCode": "+220",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GH",
      "alpha3": "GHA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a0cf662a-e375-4d3b-bf00-00a9b9da1198",
      "name": "Ghana",
      "phoneCode": "+233",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GN",
      "alpha3": "GIN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "514f259f-17c4-4b60-b7e8-6237a8d6e721",
      "name": "Guinea",
      "phoneCode": "+224",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GW",
      "alpha3": "GNB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "80719228-ad1a-4000-a0f2-e623318e7e6c",
      "name": "Guinea-Bissau",
      "phoneCode": "+245",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CI",
      "alpha3": "CIV",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "429a2203-17f7-4580-9cd4-654dc9d32cca",
      "name": "Ivory Coast",
      "phoneCode": "+225",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KE",
      "alpha3": "KEN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "cfafae3d-dbb8-486d-b214-a896c4ca170d",
      "name": "Kenya",
      "phoneCode": "+254",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LS",
      "alpha3": "LSO",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "dc75549c-c5b6-49cb-a3a6-994070e6b064",
      "name": "Lesotho",
      "phoneCode": "+266",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LR",
      "alpha3": "LBR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "1060f05e-f045-4b60-a31b-e2767844e074",
      "name": "Liberia",
      "phoneCode": "+231",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LY",
      "alpha3": "LBY",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "4d70b863-96db-4e9a-8f91-ad6c67be4876",
      "name": "Libya",
      "phoneCode": "+218",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MG",
      "alpha3": "MDG",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d23215b6-a794-4daa-ac98-9aa0161e96e7",
      "name": "Madagascar",
      "phoneCode": "+261",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MW",
      "alpha3": "MWI",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "2b032349-7c71-44b1-9a8a-bc44fab5d8fb",
      "name": "Malawi",
      "phoneCode": "+265",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ML",
      "alpha3": "MLI",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d0cae7cf-f1b9-4c9f-a47d-b63df298ae67",
      "name": "Mali",
      "phoneCode": "+223",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MR",
      "alpha3": "MRT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d5a6e40b-bb5d-43ec-974d-17106aaccaa6",
      "name": "Mauritania",
      "phoneCode": "+222",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MU",
      "alpha3": "MUS",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "dfd079bf-9180-4b51-8606-71b95b97ae53",
      "name": "Mauritius",
      "phoneCode": "+230",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MA",
      "alpha3": "MAR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "45d16386-8bc0-47c1-bbb5-b7cda2c77825",
      "name": "Morocco",
      "phoneCode": "+212",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MZ",
      "alpha3": "MOZ",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a8ec4eef-0786-4e18-b23d-b2c910268398",
      "name": "Mozambique",
      "phoneCode": "+258",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NA",
      "alpha3": "NAM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "43b27521-97f8-4035-8f7d-0395b6fd464d",
      "name": "Namibia",
      "phoneCode": "+264",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NE",
      "alpha3": "NER",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "cc9ddb8b-d120-4204-ad69-3caae719c4ea",
      "name": "Niger",
      "phoneCode": "+227",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NG",
      "alpha3": "NGA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "38398315-8d43-4d9f-bb02-f4fdb2d0c3f9",
      "name": "Nigeria",
      "phoneCode": "+234",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CG",
      "alpha3": "COG",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "22121aa4-4819-4afe-9cd0-e0b1c5c84584",
      "name": "Republic of the Congo",
      "phoneCode": "+242",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "RW",
      "alpha3": "RWA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "374bbc2d-076c-47b6-9459-7a2e6bb1f251",
      "name": "Rwanda",
      "phoneCode": "+250",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ST",
      "alpha3": "STP",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "5da15791-9b2c-453a-ab1f-0426024d8888",
      "name": "Sao Tome and Principe",
      "phoneCode": "+239",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SN",
      "alpha3": "SEN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c7bd6ff7-ded9-4c93-b3dc-a99a1cb7af57",
      "name": "Senegal",
      "phoneCode": "+221",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SC",
      "alpha3": "SYC",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c9127977-18b0-46ae-9dcc-7e64b74e4113",
      "name": "Seychelles",
      "phoneCode": "+248",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SL",
      "alpha3": "SLE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "783e8aea-22c7-44a5-8ebf-367e0a506b86",
      "name": "Sierra Leone",
      "phoneCode": "+232",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SO",
      "alpha3": "SOM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a618ab4f-7680-488d-9589-f59fb6bb68a6",
      "name": "Somalia",
      "phoneCode": "+252",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ZA",
      "alpha3": "ZAF",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "4baa3ce4-431f-4847-a9c7-c7dd45835163",
      "name": "South Africa",
      "phoneCode": "+27",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SS",
      "alpha3": "SSD",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d1bde31b-bb3a-45f3-ab2d-380dcd471d43",
      "name": "South Sudan",
      "phoneCode": "+211",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SD",
      "alpha3": "SDN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ca61edbc-1bb5-4c3c-bae7-d8695865c0fe",
      "name": "Sudan",
      "phoneCode": "+249",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SZ",
      "alpha3": "SWZ",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "98322624-4ac4-432e-921a-9b735869c832",
      "name": "Eswatini",
      "phoneCode": "+268",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TZ",
      "alpha3": "TZA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "201f681b-8759-4490-bebd-48e52dedd9cc",
      "name": "Tanzania",
      "phoneCode": "+255",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TG",
      "alpha3": "TGO",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0c655aad-cb16-4b9e-a9d2-90d0229c565a",
      "name": "Togo",
      "phoneCode": "+228",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TN",
      "alpha3": "TUN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "f80e9111-92bc-4f18-805a-64b7e0c05935",
      "name": "Tunisia",
      "phoneCode": "+216",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "UG",
      "alpha3": "UGA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ff1f4026-0e73-48f9-a323-c2d859333fd2",
      "name": "Uganda",
      "phoneCode": "+256",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ZM",
      "alpha3": "ZMB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "69b7948d-da25-4d08-95cc-26333821d316",
      "name": "Zambia",
      "phoneCode": "+260",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "ZW",
      "alpha3": "ZWE",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "62c43257-845a-48b7-b8f5-df3f63f9c668",
      "name": "Zimbabwe",
      "phoneCode": "+263",
      "region": "AFRICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AG",
      "alpha3": "ATG",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "cfc08c32-e323-43fb-ac6d-23184adc651b",
      "name": "Antigua and Barbuda",
      "phoneCode": "+1-268",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BS",
      "alpha3": "BHS",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "2b8dc275-ee15-4f9e-a52c-5516d74e44fd",
      "name": "Bahamas",
      "phoneCode": "+1-242",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BB",
      "alpha3": "BRB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "9bf79869-f690-4718-a7d4-530a8b7b6046",
      "name": "Barbados",
      "phoneCode": "+1-246",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BZ",
      "alpha3": "BLZ",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "cd6aa040-ea9f-49e2-b1f5-0663d34b9bf6",
      "name": "Belize",
      "phoneCode": "+501",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CA",
      "alpha3": "CAN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "04ec6fbb-a910-4657-af20-30e7f79af272",
      "name": "Canada",
      "phoneCode": "+1",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CR",
      "alpha3": "CRI",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0e85fadf-2ce4-43e6-be86-b6d01038c3dc",
      "name": "Costa Rica",
      "phoneCode": "+506",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CU",
      "alpha3": "CUB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ac1299e3-7897-4c88-9448-e68853f7be24",
      "name": "Cuba",
      "phoneCode": "+53",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "DM",
      "alpha3": "DMA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "8e38ea8e-5a86-4ea7-ae81-68c30dc996de",
      "name": "Dominica",
      "phoneCode": "+1-767",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "DO",
      "alpha3": "DOM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "408f61bb-13a4-4391-900e-c053f6b12f09",
      "name": "Dominican Republic",
      "phoneCode": "+1-809",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SV",
      "alpha3": "SLV",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "145f4adf-5465-46f2-8497-5790560392e7",
      "name": "El Salvador",
      "phoneCode": "+503",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GD",
      "alpha3": "GRD",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "902374cf-17f5-4b84-a092-f7b53195f9c1",
      "name": "Grenada",
      "phoneCode": "+1-473",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GT",
      "alpha3": "GTM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c64e3f22-8b34-4707-a9cd-41b2ed3c5b57",
      "name": "Guatemala",
      "phoneCode": "+502",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "HT",
      "alpha3": "HTI",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "31b6df02-274e-47ee-99ef-33810e381af2",
      "name": "Haiti",
      "phoneCode": "+509",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "HN",
      "alpha3": "HND",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "daa68750-bb2d-4ac0-ad11-643edc1a67cf",
      "name": "Honduras",
      "phoneCode": "+504",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "JM",
      "alpha3": "JAM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "44b8cbba-77d6-4273-8bdd-ca1170a26194",
      "name": "Jamaica",
      "phoneCode": "+1-876",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MX",
      "alpha3": "MEX",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "4dbc839e-827c-4c95-b5cb-277485bc1300",
      "name": "Mexico",
      "phoneCode": "+52",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NI",
      "alpha3": "NIC",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "aa1c07ac-06b3-4a85-bc61-36c11d5634fd",
      "name": "Nicaragua",
      "phoneCode": "+505",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PA",
      "alpha3": "PAN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "dff67f30-22e1-4ba5-be0b-80c09e3e8504",
      "name": "Panama",
      "phoneCode": "+507",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KN",
      "alpha3": "KNA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "e2ca2eca-c061-450f-a215-45a2339b9f01",
      "name": "Saint Kitts and Nevis",
      "phoneCode": "+1-869",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "LC",
      "alpha3": "LCA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "a582691f-c9c5-439f-9d5e-c99fba4b9460",
      "name": "Saint Lucia",
      "phoneCode": "+1-758",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "VC",
      "alpha3": "VCT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "caf62df2-da27-47f7-880b-c668dbb9123f",
      "name": "Saint Vincent and the Grenadines",
      "phoneCode": "+1-784",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TT",
      "alpha3": "TTO",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "df1cae8e-3e7e-4046-bdf8-717949d5c59b",
      "name": "Trinidad and Tobago",
      "phoneCode": "+1-868",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "US",
      "alpha3": "USA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "e778c47e-0258-48d9-a2d9-41ec8b7afd38",
      "name": "United States of America",
      "phoneCode": "+1",
      "region": "NORTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AR",
      "alpha3": "ARG",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "38758e4d-1f54-4e1c-86f5-9af2ac2e89ed",
      "name": "Argentina",
      "phoneCode": "+54",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BO",
      "alpha3": "BOL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c7cf5308-463b-49ba-b38b-37816388b2a1",
      "name": "Bolivia",
      "phoneCode": "+591",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "BR",
      "alpha3": "BRA",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "4d875f1e-74f2-4928-8794-bf49928cbfac",
      "name": "Brazil",
      "phoneCode": "+55",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CL",
      "alpha3": "CHL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "0ebc4819-4c3a-47cb-991a-30bba91518c7",
      "name": "Chile",
      "phoneCode": "+56",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "CO",
      "alpha3": "COL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "9e142e10-41eb-4422-8c95-b0078550abf2",
      "name": "Colombia",
      "phoneCode": "+57",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "EC",
      "alpha3": "ECU",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "9fd66add-7fc0-4a6e-9a56-41295dd47858",
      "name": "Ecuador",
      "phoneCode": "+593",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "GY",
      "alpha3": "GUY",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "1f748ab7-61ba-4419-9e5b-5f63f04755c0",
      "name": "Guyana",
      "phoneCode": "+592",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PY",
      "alpha3": "PRY",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "827f2760-b511-460f-b1bb-4ef6f9cf06da",
      "name": "Paraguay",
      "phoneCode": "+595",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PE",
      "alpha3": "PER",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "35a556a1-b408-4234-b1bc-c2121cb37aaf",
      "name": "Peru",
      "phoneCode": "+51",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SR",
      "alpha3": "SUR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "d29569a9-dca7-4b15-9adc-8db56b4c6477",
      "name": "Suriname",
      "phoneCode": "+597",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "UY",
      "alpha3": "URY",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "09e6dab3-e511-48c7-ac14-f8321a8dbbba",
      "name": "Uruguay",
      "phoneCode": "+598",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "VE",
      "alpha3": "VEN",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "68c12198-cecb-4b4f-bb56-63b4e602210b",
      "name": "Venezuela",
      "phoneCode": "+58",
      "region": "SOUTH_AMERICA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "AU",
      "alpha3": "AUS",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "6d54fa87-f6eb-4896-ae76-d9d6f0dec69b",
      "name": "Australia",
      "phoneCode": "+61",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "FJ",
      "alpha3": "FJI",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "1ae842c9-9b2f-4955-987a-86d594879699",
      "name": "Fiji",
      "phoneCode": "+679",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "KI",
      "alpha3": "KIR",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "76cceb2d-3a20-4c9d-a5fe-963695ad8c4e",
      "name": "Kiribati",
      "phoneCode": "+686",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "MH",
      "alpha3": "MHL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "02c9e9fc-549b-498c-ac52-be10780dbeb3",
      "name": "Marshall Islands",
      "phoneCode": "+692",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "FM",
      "alpha3": "FSM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "63990aed-8572-41df-908f-c73b6d745055",
      "name": "Micronesia",
      "phoneCode": "+691",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NR",
      "alpha3": "NRU",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "6a44ca47-397e-4876-a54d-ba4067814e8e",
      "name": "Nauru",
      "phoneCode": "+674",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "NZ",
      "alpha3": "NZL",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "f0a619ee-f6ed-4905-9fd7-ce9670fb53e6",
      "name": "New Zealand",
      "phoneCode": "+64",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PW",
      "alpha3": "PLW",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "408ff625-b2a4-49db-b16e-cb68c712ca73",
      "name": "Palau",
      "phoneCode": "+680",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "PG",
      "alpha3": "PNG",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "e5b2a59a-d793-4b5f-82f2-f1cb061b10e9",
      "name": "Papua New Guinea",
      "phoneCode": "+675",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "WS",
      "alpha3": "WSM",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "cbd2b8f9-735f-4f0f-bb9e-7a88cd646dd1",
      "name": "Samoa",
      "phoneCode": "+685",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "SB",
      "alpha3": "SLB",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "9fba9559-cafc-4378-ad44-614ceea70631",
      "name": "Solomon Islands",
      "phoneCode": "+677",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TO",
      "alpha3": "TON",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "ae75da9b-f6b3-4627-b46d-b7fb7e45c9b2",
      "name": "Tonga",
      "phoneCode": "+676",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "TV",
      "alpha3": "TUV",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "c4f03b92-56dc-4f01-88ef-fe3c8e440522",
      "name": "Tuvalu",
      "phoneCode": "+688",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    },
    {
      "alpha2": "VU",
      "alpha3": "VUT",
      "createdAt": "2024-10-18T18:15:49.271218",
      "id": "96a5241f-0683-493d-a558-93c352e2994a",
      "name": "Vanuatu",
      "phoneCode": "+678",
      "region": "OCEANIA",
      "sortOrder": 3,
      "updatedAt": "2024-10-18T18:15:49.271218"
    }
  ],
  "errors": null,
  "meta": {
    "count": 195
  }
}
